import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import Breadcrumb from "./BreadCrumb";
import { Col, Row } from "react-bootstrap";

interface RouteTitles {
  [key: string]: { title: string; subtitle?: string; icon?: string };
}

interface PageTitleProps {
  routes: RouteTitles;
}

const PageTitle: React.FC<PageTitleProps> = ({ routes }) => {
  const location = useLocation();
  const { id } = useParams(); // Captura o ID, se houver na URL

  // Normaliza a rota removendo IDs dinâmicos
  const normalizePath = (path: string) => {
    return path.replace(/\d+/g, ":id"); // Substitui números por :id para rotas dinâmicas
  };

  const currentPath = normalizePath(location.pathname);
  const pageData = routes[currentPath] || { title: "Página Desconhecida" };

  useEffect(() => {
    let title = pageData.title;

    // Se for uma página de edição, adiciona o ID ao título
    if (currentPath.includes("/usuarios/:id/edit") && id) {
      title = `Editar Usuário #${id}`;
    }

    document.title = title; // Atualiza o título do navegador
  }, [currentPath, id]);

  return (
    <Row className="d-flex justify-content-between container-fluid mb-4">
      <Col className="d-flex align-items-end">
        {/* Usa Font Awesome para exibir o ícone */}
        {pageData.icon && <i className={`${pageData.icon} me-2 fs-3`}></i>}

        <h2 className="m-0">{id ? `Editar Usuário #${id}` : pageData.title}</h2>
        {pageData.subtitle && <h4 className="text-muted m-0 ms-2">{pageData.subtitle}</h4>}
      </Col>
      <Col className="d-flex align-items-start justify-content-end">
        <Breadcrumb />
      </Col>

    </Row>
  );
};

export default PageTitle;
